<sbb-header-lean
  label="Netzgrafik-Editor"
  [subtitle]="'app.version' | translate: {version: version}"
  class="sbb-header-fixed-columns noprint"
>
  <sbb-app-chooser-section [label]="'app.user-guide' | translate" class="noprint">
    <a
      href="https://github.com/OpenRailAssociation/netzgrafik-editor-frontend/blob/main/documentation/USERMANUAL.md"
      class="nav-element"
      target="_blank"
    >
      {{ "app.user-manual" | translate }}
    </a>
  </sbb-app-chooser-section>
  <sbb-header-environment class="noprint" *ngIf="environmentLabel">{{
    environmentLabel
  }}</sbb-header-environment>
  <sbb-usermenu
    class="noprint"
    [menu]="menu"
    *ngIf="authenticated | async"
    [userName]="email"
    [displayName]="userName"
  >
    <sbb-icon svgIcon="user-small" *sbbIcon></sbb-icon>
  </sbb-usermenu>
  <sbb-menu #menu="sbbMenu">
    <sbb-language-selector
      [currentLanguage]="currentLanguage"
      (languageChange)="language = $event"
      variantClass="language-selector-menu"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    ></sbb-language-selector>
    <hr />
    <button sbb-menu-item (click)="logout()">
      <sbb-icon svgIcon="exit-small" class="sbb-icon-fit"></sbb-icon>
      <span>{{ "app.logout" | translate }}</span>
    </button>
  </sbb-menu>
</sbb-header-lean>
<sbb-language-selector
  *ngIf="disableBackend"
  [currentLanguage]="currentLanguage"
  (languageChange)="language = $event"
  variantClass="language-selector-standalone noprint"
></sbb-language-selector>
<ng-container *ngIf="!disableBackend">
  <sbb-navigation-bar class="noprint"></sbb-navigation-bar>
</ng-container>
<router-outlet *ngIf="authenticated | async; else loading"></router-outlet>
<ng-template #loading>
  <ng-container *ngIf="!disableBackend">
    <sbb-loading-indicator mode="big"></sbb-loading-indicator>
    <div class="login-message">{{ "app.login" | translate }}</div>
  </ng-container>
  <ng-container *ngIf="disableBackend">
    <sbb-netzgrafik-editor></sbb-netzgrafik-editor>
  </ng-container>
</ng-template>
